import React from 'react';
import { CarAssistantAPI } from "../api/CarAssistantAPI";
import ChatBot from "./ChatBot";


const CarAssistant: React.FC = () => {

  return (
    <ChatBot name="car-assistant" api={CarAssistantAPI} />
  );
};

export default CarAssistant;
